import React from "react";
import { FormGroups } from "../../ReusableComponents/FormGroups/FormGroups";
import { FieldControl } from "react-reactive-form";
import { TextInput } from "./FormInput";

const Email = (props) => {
    const {keyName,label} = props;
  return (
    <FormGroups>
      <FieldControl
        name={keyName}
        render={TextInput}
        meta={{
          label: label,
          type: "text",
          placeholder: "",
          valid: false,
        }}
      />
    </FormGroups>
  );
};

export default Email;